import stack from '@/assets/images/cards/stack.png'
import StarAI from '@/assets/images/cards/StarAI.png'
import show from '@/assets/images/cards/show.svg'
import share from "@/assets/images/share.png"
import selectActive from "@/assets/images/selectActive.png"
import soldOutImg from '@/assets/images/cards/soldOut.png'
import soldOutImg_zh from '@/assets/images/cards/soldOut_zh.png'
import { getShopPayCountHandle } from "@/api/starpay.js"
import { updateDownLoadCount } from '@/api/url.js'
import selling from '@/assets/images/cards/selling.png'
import selling_zh from '@/assets/images/cards/selling_zh.png'
import coin from '@/assets/images/coin.png'
import coins from '@/assets/images/redpacket/coins.png'
import close from "@/assets/images/task/close.png"
import bg from "@/assets/images/talk/bg.png"
import report from '@/assets/images/cards/report.svg'
import { Popup, Toast } from 'react-vant'
import { getShopPayConfig } from "@/api/shop.js"
import { v4 as uuidv4 } from 'uuid';
import '@/styles/index.less'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { getCardSaleCards, postBuy, getUserInfo, getCards, checkCardStatus, postSetting, getSetting, getRefiningTips, reportCard, getThumbup, postWarningInformation } from '@/api/url.js'
import { useDispatch, useSelector } from 'react-redux'
import CardItem from '../../components/CardItem'
import { coinMovementOffset, convertNumber, downloadFile, formatIdString, formatNumber, FormattingNumber, FormattingTwoNumber } from '../../utils'
import { changeHomePage, changeUserInfo } from '../../store/module/tabbar'
import { changeCardData, changeSaleCardData } from '../../store/module/tasks'
import { addRefiningCardList, removeRefiningCardList, changeIsSelect } from '../../store/module/search'
import PromptDialog from '../../components/PromptDialog'
import usePlaySound from "@/hook/usePlaySound.tsx"
import activeImg from "../../assets/images/selectActive.png"
import { changeSettings } from '../../store/module/settins'
import Back from '../../components/common/BackComp'
import ButtonComp from '../../components/common/ButtonComp'
import PublicDialog from '../../components/PublicDialog'
import { changeCardReport } from '../../store/module/card'
import NsfwPay from '../../components/nsfw/nsfwPay'
import CloseComp from '../../components/common/CloseComp'
import GetCoinAnimationDialog from '../../components/GetCoinAnimationDialog'
import GlassmorphismCanvas from '../../hook/useBlur'
import { changeLoginState } from '../../store/module/h5Login'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ShareContent from '../../components/ShareContent'
import ShareComp from '../../components/common/ShareComp'
import { changeShopCount } from '../../store/module/lottery'
import PayDialog from '../../components/common/PayDialog'

interface SaleProps {
    setCardsData?: Function
    setSaleCardsData?: Function
    scrollToTop?: Function
    setPage?: Function
    saleCardsData: Array<any>
    isPadding?: Boolean
    type?: string
    callback?: Function
    sort?: Number
    typeActive?: Number
}
const Sale = ({ setCardsData, saleCardsData, setSaleCardsData, isPadding = true, type = "", setPage, scrollToTop, callback, sort, typeActive }: SaleProps) => {
    const { t, i18n } = useTranslation();
    const closeAudioRef = useRef<any>(null)
    const [seq, setSeq] = useState<any>({})
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const [payList, setPay] = useState<any>([])
    const coinDomCoordinate = useSelector((state: any) => state.tabbar.coinDomCoordinate)
    const [buttonActive, setVuttonActive] = useState(2);
    const dispatch = useDispatch()
    const shareStatusList = useSelector((state: any) => state.progress.shareStatusList)
    const closePlaySound = usePlaySound('close')
    const [buyCard, setBuyCard] = useState({})
    const [loading, setLoading] = useState(false)
    const [claimPointsDialog, setClaimPointsDialog] = useState(false)
    const [purchaseSuccessfulDialog, setPurchaseSuccessfulDialog] = useState(false)
    const [buyPopup, setBuyPopup] = useState(false)
    const [dialog, setDialog] = useState(false)
    const [confirmBuyPopup, setConfirmBuyPopup] = useState(false)
    const { shopCount } = useSelector((state: any) => state.lottery)
    const popupRef = useRef<any>(null)
    const dialogRef = useRef<any>(null)
    const [payDialog, setPayDialog] = useState<any>(false)
    const [promptText, setPromptText] = useState<any>('')
    const [active, setActive] = useState<number>(-1)
    const [showPayDialog, setShowPayDialog] = useState(false)
    const userInfo = useSelector((state: any) => state.tabbar.userInfo)
    const refiningCardList = useSelector((state: any) => state.search.refiningCardList)
    const address_params = localStorage.getItem('address_params')
    const [text, setText] = useState<any>('')
    const [coin_NSFW, setCoin_NSFW] = useState(false)
    const [is_report, setReport] = useState(false)
    const settings = useSelector((state: any) => state.settings.settings)
    const card_report = useSelector((state: any) => state.card.card_report)
    const [actionArr, setActionCard] = useState<any>({})
    const cardId: any = searchParams.get("cardId") as string;
    const id: any = searchParams.get("type") as string;
    const { pathname } = useLocation();
    const _cardType = useSelector((state: any) => state.tasks.cardType)
    const cardType = useRef<any>(null)
    const isNft = useRef<any>(false)
    const [shareDialog, setShareDialog] = useState(false)
    useEffect(() => {
        const gatCardInfo = async () => {
            try {
                const res = await checkCardStatus(cardId)
                if (res.code == 0) {
                    if (res.data.is_nsfw) {
                        setPromptText(t("h5.text6"))
                        setDialog(true)
                    } else {
                        setActionCard(res.data)
                        cardType.current = res.data.card_type
                        isNft.current = res.data.is_nft
                        setBuyPopup(true);
                    }
                } else {
                    getCardsData()
                    setPromptText(t("h5.text7"))
                    setDialog(true)
                }
            } catch {
                getCardsData()
                setPromptText(t("h5.text7"))
                setDialog(true)
            }
        }
        if (!localStorage.getItem('token') && cardId) {
            gatCardInfo()
        }
    }, [])



    const getPayConfigHandle = async () => {
        const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
            duration: 0
        })
        try {
            const { code, data } = await getShopPayConfig(10)
            if (code == 0) {
                let list = data.filter((item: any) => item.count == 1)
                list = list.map((item: any) => {
                    return {
                        ...item,
                        title: "Image Download"
                    }
                });
                setPay(list)
            }
            toast.clear()
        } catch (e) {
            toast.clear()
        }

    }

    const setUserInfo = useCallback(async () => {
        const UserInfo = await getUserInfo(address_params)
        if (UserInfo.code == "0") {
            dispatch(changeUserInfo(UserInfo.data))

        }
    }, [])

    useEffect(() => {
        if (cardId) {
            getCardInoHandle(cardId)
        }
    }, [cardId])
    const setDownLoadCount = async () => {
        dispatch(changeShopCount({ type: 3, count: await getShopPayCountHandle(10) }))

    }
    useEffect(() => {
        setDownLoadCount()
        getPayConfigHandle()
    }, [])
    const getCardInoHandle = async (id: string) => {
        const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
        });
        const { code, data } = await checkCardStatus(id)
        toast.clear()
        if (code == 0) {
            setActionCard(data)
            setBuyPopup(true)
        }
    }

    const getCardsData = useCallback(async () => {
        let ID = window.localStorage.getItem("userId") || "";

        const resSale = await getCardSaleCards(1, 20, sort)
        const res = await getCards(ID, 1, 20, -1)
        if (res.code == 0) {
            dispatch(changeCardData(res.data.data))
            setCardsData && setCardsData(res.data.data)
        }
        if (resSale.code == 0) {
            setSaleCardsData && setSaleCardsData(resSale.data.data)
            dispatch(changeSaleCardData(resSale.data.data))
        }
    }, [sort])

    async function Buy(id: string, points: string) {
        setBuyPopup(false)
        setConfirmBuyPopup(false)
        // closePlaySound()
        setText(t("other.attention"))
        if (userInfo.points > points) {
            try {
                const res = await postBuy(Number(id))
                if (res.code == 0) {
                    setSeq(res.data)
                    setText('')
                    setUserInfo()
                    setPromptText(t("card.sale.purchase_successful") + "🎉")
                    setPurchaseSuccessfulDialog(true)
                } else if (res.code == 65541) {

                    setPromptText(t("card.sale.card_already_bought"))
                    setDialog(true)
                }
                else if (res.code == 65547) {
                    setPromptText(t("card.sale.insufficient_star"))
                    setDialog(true)
                } else if (res.code == 65550) {
                    setPromptText(t("card.sale.cannot_buy_own_cards"))
                    setDialog(true)
                } else {
                    setPromptText(t("card.sale.purchase_failed"))
                    setDialog(true)
                }
                setPage && setPage(2)
                scrollToTop && scrollToTop()
                // getCardsData()
                callback ? '' : getCardsData()
            } catch (err) {
                setPromptText(t("card.sale.purchase_failed"))
                setDialog(true)
            }
        } else {
            setPromptText(t("card.sale.insufficient_star"))
            setDialog(true)
        }
    }

    const AudioRef = useRef<any>()
    const getCoinAnimation = useCallback((x: any, y: any) => {
        const R = 100; // 扩散半径
        const time = 0.25; //扩散过度时间
        const time2 = 1; // 收集过度时间
        const w = 26; // 金币大小
        const Num = 8 //金币数量

        const screenWidth = window.innerWidth;
        const pcX = screenWidth > 768 ? screenWidth > 1536 ? (screenWidth / 2) - 220 : screenWidth > 1920 ? (screenWidth / 2) - 250 : (screenWidth / 2) - 187.5 : 0
        setlits((x - pcX), y)

        if (AudioRef.current) {
            // AudioRef.current.currentTime = 0;
            AudioRef.current.play()
        }
        const total = document.getElementsByClassName('total_1')[0] // 获取金币最终飞向

        function setlits(X: any, Y: any) {
            var species = document.createElement('div');
            species.className = 'species'
            for (let i = 0; i < Num; i++) {
                var img = document.createElement('img');
                img.className = 'speciesstyle'
                img.style.width = w + 'px',
                    img.style.height = w + 'px',
                    img.style.left = X + 'px',
                    img.style.top = Y + 'px',
                    img.style.transform = 'translate(0%, 0%)',
                    img.style.transition = `${time}s`
                img.src = coin
                species.appendChild(img);
            }
            boxRef.current.appendChild(species)
            setTimeout(() => {
                clickss(X, Y)
            }, 0)
        }
        // 计算金币扩散范围和坐标
        function clickss(X: number, Y: number) {
            const specielist: any = document.getElementsByClassName('speciesstyle')
            const num = specielist.length
            const center = {
                x: X,
                y: Y
            }
            for (let i = 0; i < num; i++) {
                const xz = center.x + Math.floor(Math.random() * ((R * 1.1) - (R * 0.6) + 1)) + (0.6 * R) * Math.sin(2 * Math.PI * i / num)
                const yz = center.y + Math.floor(Math.random() * ((R * 1.1) - (R * 0.6) + 1)) + (0.6 * R) * Math.cos(2 * Math.PI * i / num)
                specielist[i].style.transform = `translate(${xz - (X + w / 2)}px, ${yz - (Y + w / 2)}px)`
            }
            setTimeout(() => {
                for (let i = 0; i < num; i++) {
                    specielist[i].style.transition = `${time2}s`
                    specielist[i].style.transform = `translate(0,0)`
                    specielist[i].style.left = Math.floor(total?.getBoundingClientRect().x) - pcX + 'px'
                    specielist[i].style.top = Math.floor(total?.getBoundingClientRect().y) + 'px'
                }
                // 结束清除蒙层
                setTimeout(() => {
                    remove()
                }, (Number(time2) + 0.5) * 500) //飞行时间结束

            }, (Number(time) + 0.5) * 500) //扩散时间结束
        }
        // 清除dom
        function remove() {
            document.getElementsByClassName('species')[0].remove()
        }
        setDialog(false)
    }, [coinDomCoordinate, dialog])

    const promptCard: any = useMemo(() => {
        return promptText.includes(t('card.sale.purchase_successful')) ? buyCard : { seq: '', description: "", image: '', is_official: "", level: '', }

    }, [promptText, active, dialog])


    const [reportIndex, setReportIndex] = useState<any>([])
    async function reportPost() {
        try {
            let [code] = await reportCard({ id: actionArr?.id, type: reportIndex })
            if (code != "0") {
                await reportCard()
            }
            setPage && setPage(2)
            scrollToTop && scrollToTop()
            callback ? '' : getCardsData()
            setReport(false)
            setBuyPopup(false)
        } catch {
            setPage && setPage(2)
            scrollToTop && scrollToTop()
            callback ? '' : getCardsData()
            setReport(false)
            setBuyPopup(false)
        }
        setReportIndex([])
    }
    async function Thumbup(id: any) {
        if (!localStorage.getItem('token')) {
            dispatch(changeLoginState(true))
            return
        }
        if (!loading) {
            setLoading(true)

            try {
                const { data } = await getThumbup(id)
                if (!saleCardsData) return
                const newSaleCardsData: any = saleCardsData.map((el: any) => {

                    let newLikeCount = JSON.parse(JSON.stringify(el))
                    if (el.id == id) {
                        newLikeCount.like_count = data.like_count
                    }
                    return newLikeCount
                })
                setActionCard({
                    ...actionArr,
                    like_count: data.like_count
                })
                setSaleCardsData(newSaleCardsData)

                setLoading(false)
            } catch (error) {
                setLoading(false)
            }
        }
    }

    const downLoadHandle = async (item: any) => {
        if (shopCount[3] > 0) {
            const params = {
                url: item.image,
                file_name: item.id
            }
            try {
                downloadFile(params)
                await updateDownLoadCount(item.id)
                getSaleCardInoHandle()
            } catch (e) {
            }
        } else {
            setShowPayDialog(true)
            console.log("单次付费")
        }

    }
    const getSaleCardInoHandle = async () => {
        dispatch(changeShopCount({ type: 0, count: await getShopPayCountHandle(3) }))
        dispatch(changeShopCount({ type: 2, count: await getShopPayCountHandle(11) }))
        dispatch(changeShopCount({ type: 3, count: await getShopPayCountHandle(10) }))
    }
    useEffect(() => {
        getSaleCardInoHandle()
    }, [])
    function reportText() {
        return (
            <div className=' pt-10 px-[14px] relative'>
                <CloseComp position="absolute" top={14} right={16} callBack={() => { setReport(false) }}></CloseComp>
                <p className=' text-center text-[20px] mb-5 leading-6 font-bold text-[#333333]'>{t("card.sale.report_inappropriate_image")}</p>
                {Array.isArray(card_report.card_report) && card_report.card_report.map((el: any, index: number) =>
                    <div key={`${index}-Inappropriate`} className='flex mt-[10px] cursor-pointer gap-[10px]' onClick={() => {
                        if (reportIndex.includes(index + 1)) {
                            setReportIndex(reportIndex.filter((el: any) => el != index + 1))
                        } else {
                            setReportIndex([...reportIndex, index + 1])
                        }
                    }}>
                        <div style={{ border: `${reportIndex.includes(index + 1) ? '' : '1px solid #333333'}` }}
                            className='w-5 flex-shrink-0 rounded-full h-5'>
                            {reportIndex.includes(index + 1) && < img className=' h-5 w-5' src={selectActive} alt="" />}
                        </div>
                        <p className='text-[14px] leading-[18px] text-[#333] font-semibold'>{el}</p>
                    </div>
                )}
                <div className='h-[30px]'></div>
                <ButtonComp title={t("other.ok")} callBack={() => { reportPost() }}></ButtonComp>
            </div>
        )

    }

    const teleportRef = useRef(null)
    const boxRef = useRef<any>(null)
    const blurRef = useRef<any>(null)
    return (
        <>
            <div ref={boxRef} className={`${isPadding ? 'pt-12' : ''} flex px-[.1875rem] pl-[10px] pr-[.75rem] relative flex-wrap justify-between`}>
                {saleCardsData && saleCardsData?.length > 0 && saleCardsData?.map((el: any, index: number) =>
                    <div style={{ width: 'calc(50%)' }} key={`saleCardsData${index}`} className={`pt-[8px] pl-[5px] pr-[.3125rem] pb-[.1875rem] relative `}>
                        <div onClick={async () => {
                            closePlaySound()
                            if (type) {
                                if (!el.is_official && el.state == 2) { return false }
                                if (refiningCardList.find((item: any) => item.id == el.id)) {
                                    dispatch(removeRefiningCardList(el.id))
                                    return false;
                                }
                                if (refiningCardList.length < 2) {
                                    dispatch(addRefiningCardList(el))
                                } else {
                                    dispatch(changeIsSelect(true))
                                    setTimeout(() => {
                                        dispatch(changeIsSelect(false))
                                    }, 1200)
                                }

                            } else {
                                if (el.count == 0) return false
                                try {
                                    const res = await checkCardStatus(el.id)
                                    if (res.code == 0) {
                                        setActionCard(res.data)
                                        cardType.current = res.data.card_type
                                        isNft.current = res.data.is_nft
                                        if (pathname == '/cards') {
                                            navigate(`/cards?type=Sale&cardId=${el.id}`)
                                        }
                                        setBuyPopup(true);

                                        setActive(index);
                                    } else {
                                        getCardsData()
                                        setPromptText(t("card.sale.someone_else_bought_card"))
                                        setDialog(true)
                                    }
                                } catch {
                                    getCardsData()
                                    setPromptText(t("card.sale.someone_else_bought_card"))
                                    setDialog(true)
                                }
                            }
                        }} ref={blurRef} className="overflow-hidden w-full z-[2] flex items-center justify-center p-[.125rem] h-fit rounded-[.625rem] relative">
                            {
                                type != 'refining' && el.is_nsfw && !settings.star_nsfw && <GlassmorphismCanvas
                                    imageUrl={el.image}
                                    x={0}
                                    y={0}
                                    width={blurRef.current?.getBoundingClientRect().width || 200}
                                    height={blurRef.current?.getBoundingClientRect().height || 300}
                                    blurRadius={40}
                                />
                            }
                            {type != 'refining' && el.is_nsfw && !settings.star_nsfw && <div className=' w-[100%] h-[100%] absolute top-0 left-0 flex items-center justify-center !backdrop-blur-[1.25rem] z-10' onClick={(e: any) => {
                                e.stopPropagation()
                                if (localStorage.getItem('token')) {
                                    if (settings.nsfw_pay_type != 0 || settings.nsfw) {
                                        if (setSaleCardsData) {
                                            const newDataList = JSON.parse(JSON.stringify(saleCardsData))
                                            newDataList[index].is_nsfw = false
                                            setSaleCardsData(newDataList)
                                        }
                                    } else {
                                        setCoin_NSFW(true)
                                    }
                                } else {
                                    dispatch(changeLoginState(true))
                                }
                            }}>
                                <img src={show} alt="" />
                            </div>}
                            <CardItem cardType={el.card_type} bonusPower={el?.bonus_power} power={el.power} enhanceLevel={type == 'refining' || (el.card_type == 2 && el.is_nft) ? el.enhance_level : ""} property={el.property} mint_state={el.mint_state} state={type == "refining" ? el.state : 0} price={el.price} saleCardsData={saleCardsData} setSaleCardsData={setSaleCardsData} pageName={'sale'} no={el.seq ? `No. ${el.seq}` : 'No. ?'} id={el.id} like={el.like_count} view={el.view_count} image={el.image} level={el.is_official ? 6 : el.level + 1} text={el.description}></CardItem>

                            {
                                type && refiningCardList.find((item: any) => item.id == el.id) &&
                                <div className="isActive absolute top-[.75rem] right-[.75rem]">
                                    <img className="w-5 h-5" src={activeImg} alt="" />
                                </div>

                            }

                            {(el.count == 0 && el.is_official && !type) && <div className='absolute top-0 left-0 w-full h-full bg-[#000000] opacity-[0.5] z-[2]'></div>}

                            {el.count == 0 && el.is_official && !type && <img className='absolute w-[7.1875rem] top-[50%] right-[50%] translate-x-[50%] z-[3] translate-y-[-50%]' src={i18n.language == 'en' ? soldOutImg : soldOutImg_zh} alt="" />}
                            {
                                type && el.state == 2 && <div className='absolute top-0 left-0 w-full h-full bg-[#000000] opacity-[0.5] z-[2]'></div>
                            }
                            {
                                type && el.state == 2 && <img className='absolute w-[7.1875rem] top-[50%] right-[50%] translate-x-[50%] z-[3] translate-y-[-50%]' src={i18n.language == 'en' ? selling : selling_zh} alt="" />
                            }
                        </div>
                        {el.count > 1 && <img style={{ width: 'calc(100% - 1.125rem)', height: 'calc(100% - 1.125rem)' }} className='absolute bottom-[-0.1875rem] z-[1] right-[-0.0625rem]' src={stack} alt="" />}
                    </div>
                )}
            </div>
            <Popup
                destroyOnClose={true}
                closeOnPopstate={true}
                style={{ width: '100%', height: '100vh', overflow: 'hidden', backgroundColor: 'rgba(0,0,0,0)' }}
                position='right'
                overlay={false}
                ref={teleportRef}
                visible={buyPopup}>
                <div ref={popupRef} className='w-full h-full relative bg-no-repeat bg-cover' style={{ backgroundImage: `url(${actionArr?.image})`, }}>
                    <div className='new_button_shadow_1 cursor-pointer absolute z-[400] right-4 top-[10px] !rounded-[6px]'>
                        {!actionArr?.is_official && <img className='w-[18px] h-[18px]' onClick={() => {
                            if (localStorage.getItem('token')) {
                                setReport(true)
                            } else {
                                dispatch(changeLoginState(true))
                            }
                        }} src={report} alt="" />}
                    </div>

                    {/* <img className='absolute h-6 top-[.625rem] left-4 z-10' onClick={() => { closePlaySound(), setBuyPopup(false), setConfirmBuyPopup(false) }} src={left_arrow} alt="" /> */}
                    <Back position={true} callback={() => { setBuyPopup(false), setConfirmBuyPopup(false) }}></Back>
                    <div className='w-full !backdrop-blur-[1.25rem] cursor-pointer flex justify-center items-center flex-col relative z-1 h-full !py-10 px-10' onClick={() => {
                        setConfirmBuyPopup(false)
                    }}>
                        <div ref={dialogRef} className="w-[100%] items-center flex justify-center p-2 overflow-hidden relative">
                            <CardItem info={actionArr} cardType={2} noLike={true} enhanceLevel={type == 'refining' || (actionArr?.card_type == 2 && actionArr?.is_nft) ? actionArr?.enhance_level : ""} bonusPower={actionArr?.bonus_power} power={_cardType == 3 ? actionArr?.power : actionArr?.power - actionArr?.enhance_power} property={actionArr?.property} mint_state={actionArr?.mint_state} saleCardsData={saleCardsData} setSaleCardsData={setSaleCardsData} id={actionArr?.id} like={actionArr?.like_count} view={actionArr?.view_count} pageName={'sale'} no={buttonActive == 2 ? 'No. ?' : `No. ${convertNumber(actionArr?.seq)}`} image={actionArr?.image} big={true} text={actionArr?.description} level={actionArr?.is_official ? 6 : actionArr?.level + 1}></CardItem>
                        </div>
                        {<div className='mt-[12px] flex' >
                            <svg onClick={() => { downLoadHandle(actionArr) }} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="mine卡牌详情自然级" transform="translate(-176.000000, -571.000000)" fill="#FFFFFF" fillRule="nonzero">
                                        <g id="编组" transform="translate(176.000000, 571.000000)">
                                            <path d="M22.1073602,1.89263976 C20.8982732,0.676884698 19.2530494,-0.0046175326 17.5384269,2.35501392e-05 L6.46152572,2.35501392e-05 C2.8929236,2.35501392e-05 0,2.89297094 0,6.46157306 L0,17.5384743 C0,21.1070764 2.8929236,24 6.46152572,24 L17.5384269,24 C21.1070291,24 23.9999764,21.1070764 23.9999764,17.5384743 L23.9999764,6.46157306 C24.0046175,4.74695065 23.3231153,3.10172677 22.1073602,1.89263976 Z M17.5384269,18.4615494 C17.5384269,18.9713497 17.1251521,19.3846245 16.6153518,19.3846245 L7.38460082,19.3846245 C6.87480052,19.3846245 6.46152572,18.9713497 6.46152572,18.4615494 C6.46152572,17.9517491 6.87480052,17.5384743 7.38460082,17.5384743 L16.6153518,17.5384743 C17.1251521,17.5384743 17.5384269,17.9517491 17.5384269,18.4615494 Z M17.2822736,12.3571384 L12.5119946,15.5374205 C12.2019395,15.744117 11.7980131,15.744117 11.4879581,15.5374205 L6.71767906,12.3571384 C6.51392605,12.22136 6.37246588,12.0101926 6.32442623,11.7701026 C6.27638658,11.5300126 6.32570375,11.2806725 6.46152572,11.0769486 C6.59730402,10.8731956 6.80847143,10.7317354 7.04856148,10.6836957 C7.28865152,10.6356561 7.53799159,10.6849733 7.7417155,10.8207952 L10.7180558,12.8054067 C10.7888864,12.852664 10.8799847,12.8570776 10.955052,12.8168889 C11.0301193,12.7767001 11.0769566,12.69844 11.0769012,12.6132917 L11.0769012,5.53849796 C11.0769012,5.02869765 11.490176,4.61542285 11.9999763,4.61542285 C12.2447911,4.61542285 12.4795788,4.71267513 12.652689,4.88578529 C12.8257992,5.05889545 12.9230514,5.29368322 12.9230514,5.53849796 L12.9230514,12.6132917 C12.9229961,12.69844 12.9698334,12.7767001 13.0449007,12.8168889 C13.1199679,12.8570776 13.2110663,12.852664 13.2818969,12.8054067 L16.2582372,10.8207952 C16.4619611,10.6849733 16.7113011,10.6356561 16.9513912,10.6836957 C17.1914812,10.7317354 17.4026486,10.8731956 17.5384269,11.0769486 C17.6742489,11.2806725 17.7235661,11.5300126 17.6755264,11.7701026 C17.6274868,12.0101926 17.4860266,12.22136 17.2822736,12.3571384 Z" id="形状"></path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            {
                                shopCount[3] > 0 && <div onClick={() => { downLoadHandle(actionArr) }} className='ml-1 text-white'>
                                    {shopCount[3]}
                                </div>
                            }
                            <div className=' relative ml-[30px]' onClick={() => {
                                setShareDialog(true)
                            }}>
                                {Array.isArray(shareStatusList?.cardDomainShare) && !shareStatusList?.cardDomainShare.every((item: any) => item.status === true) &&
                                    <div className=' absolute p-[4px] pt-[1px] pb-[2px] w-12 top-[-18px] left-[50%] -translate-x-[50%] ' style={{ background: 'linear-gradient( 125deg, #EF4444 0%, #E88585 100%)', borderRadius: '0px 9px 0px 9px' }}>
                                        <p className=' text-[12px] text-[#fff] leading-4 font-normal  flex items-center gap-1'> {shareStatusList?.cardDomainShare[1].status ? '+5k' : '+25k'} <img src={coins} className='w-[14px] h-[10px]' alt="" /></p>
                                    </div>}
                                <img src={share} className='w-[24px] h-[24px]' alt="" />
                            </div>
                        </div>}
                        {!(actionArr?.is_official && buttonActive != 2) && <>
                            <div className='w-full'>
                                <div className=' flex justify-between mt-10 items-center'>
                                    <div className={`${actionArr?.card_type == 2 ? 'hidden' : ''} flex w-full  items-center`}>
                                        <img src={coin} className='h-[1.625rem] mr-[.625rem]' alt="" />
                                        <p className='text-style-coin'>{formatNumber(+ actionArr?.price)}</p>
                                    </div>
                                    <div>
                                        <div className={`flex justify-center z-[10] font-medium text-[#E0E0E0] text-[12px] cursor-pointer leading-3 gap-[26px] items-center`}>
                                            <div onClick={(e) => {
                                                e.stopPropagation()
                                                Thumbup(actionArr?.id)
                                            }} className=' bg-[rgba(0,0,0,0.4)] font-medium text-[#E0E0E0] text-[12px] leading-3 h-4 scale-[1.5] p-1 rounded-[25px] flex items-center gap-1'>
                                                <div className=' relative'>
                                                    <svg width="9px" height="8px" viewBox="0 0 9 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                        <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                            <g id="炼化mine页面" transform="translate(-35.000000, -266.000000)" fill="#FFFFFF" fillRule="nonzero">
                                                                <g id="编组-13" transform="translate(30.000000, 262.000000)">
                                                                    <g id="编组备份-3" transform="translate(5.000000, 4.000000)">
                                                                        <path d="M6.16401541,0.0287077182 C6.91957638,-0.0868417951 7.62901168,0.148257022 8.20322002,0.700894807 C8.78665349,1.26264323 9.06633256,2.00282677 8.9866814,2.77923064 C8.90793026,3.54630167 8.49572428,4.30381763 7.8020392,4.97156051 C7.60853639,5.15799522 7.08832884,5.66130225 6.341768,6.38437556 C6.00606313,6.70969189 5.64875793,7.05567381 5.28875271,7.40498889 L4.93864762,7.74408228 L4.7995956,7.87896412 C4.6332039,8.04034529 4.3665786,8.04034529 4.2001869,7.87896412 L2.99146934,6.7056921 L2.73609064,6.4585939 C2.22338378,5.96283984 1.71060133,5.46716204 1.1977433,4.97156051 C0.50405822,4.30381763 0.0920772411,3.54652387 0.013326094,2.77923064 C-0.0663250627,2.00282677 0.213128995,1.26264323 0.796787475,0.700894807 C1.37099582,0.148257022 2.08043112,-0.086619588 2.83599209,0.0287077182 C3.39670023,0.114258799 3.96550849,0.390022169 4.50011625,0.830221382 C5.03494901,0.390244376 5.60353228,0.114258799 6.16424042,0.0287077182 L6.16401541,0.0287077182 Z" id="路径"></path>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </svg>
                                                    <svg className={`svg-celebrate ${loading ? 'svg-celebrate_active' : ''}`} width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                                                        <polygon points="10,10 20,20"></polygon>
                                                        <polygon points="10,50 20,50"></polygon>
                                                        <polygon points="20,80 30,70"></polygon>
                                                        <polygon points="90,10 80,20"></polygon>
                                                        <polygon points="90,50 80,50"></polygon>
                                                        <polygon points="80,80 70,70"></polygon>
                                                    </svg>
                                                </div>
                                                {actionArr?.like_count}
                                            </div>
                                            <div className=' bg-[rgba(0,0,0,0.4)] font-medium text-[#E0E0E0] text-[12px] scale-[1.5] leading-3 h-4 p-1 rounded-[25px] flex items-center gap-1'>
                                                <svg width="11px" height="8px" viewBox="0 0 11 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                    <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                        <g id="炼化mine页面" transform="translate(-73.000000, -266.000000)" fill="#FFFFFF" fillRule="nonzero">
                                                            <g id="编组-15" transform="translate(69.000000, 262.000000)">
                                                                <g id="编组" transform="translate(4.000000, 4.000000)">
                                                                    <path d="M5.50013508,0 C1.86589644,0 0,3.99974599 0,3.99974599 C0,3.99974599 1.4080277,8 5.50013508,8 C9.20593068,8 11,4.01534775 11,4.01534775 C11,4.01534775 9.19162421,0 5.50013508,0 L5.50013508,0 L5.50013508,0 Z M5.50839968,6.49981117 C4.17957953,6.49981117 3.21901919,5.4059633 3.21901919,3.99970588 C3.21901919,2.59332814 4.17965321,1.49976103 5.50839968,1.49976103 C6.83714616,1.49976103 7.79766965,2.59323456 7.79766965,3.99970588 C7.79766965,5.4059633 6.83715845,6.49981117 5.50839968,6.49981117 L5.50839968,6.49981117 L5.50839968,6.49981117 Z M5.50839968,2.4995412 C4.74892827,2.50144219 4.13480577,3.19616841 4.13480577,3.99971925 C4.13480577,4.80284227 4.74894055,5.4998145 5.50839968,5.4998145 C6.26782198,5.4998145 6.88190763,4.8027888 6.88190763,3.99971925 C6.88195676,3.19588766 6.26783426,2.49799296 5.50839968,2.4995412 L5.50839968,2.4995412 L5.50839968,2.4995412 Z" id="形状"></path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                                {actionArr?.view_count}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='flex w-full mt-[20px] justify-between items-center'>
                                    <div onClick={() => {
                                        dispatch(changeHomePage(
                                            {
                                                showHomePage: true,
                                                id: actionArr?.creator,
                                            }
                                        ))
                                    }} className='flex items-center'>
                                        {Array.isArray(actionArr?.creator) && <p className=' text-[.875rem] font-semibold leading-[1rem] text-[#a6a6a6]'>{t("card.sale.creator")}: {actionArr?.creator?.length > 7 ? formatIdString(actionArr?.creator) : actionArr?.creator}</p>}
                                        <img src={actionArr?.is_official ? StarAI : actionArr?.avatar} className='h-[1.25rem] ml-2' alt="" />
                                    </div>

                                    {/* <div className=' relative ml-[30px]' onClick={() => {
                                        setShareDialog(true)
                                    }}>
                                        {Array.isArray(shareStatusList?.cardDomainShare) && !shareStatusList?.cardDomainShare[0].status &&
                                            <div className=' absolute p-[4px] pt-[1px] pb-[2px] w-12 top-[-18px] left-[50%] -translate-x-[50%] ' style={{ background: 'linear-gradient( 125deg, #EF4444 0%, #E88585 100%)', borderRadius: '0px 9px 0px 9px' }}>
                                                <p className=' text-[12px] text-[#fff] leading-4 font-normal  flex items-center gap-1'> +5k <img src={coins} className='w-[14px] h-[10px]' alt="" /></p>
                                            </div>}
                                        <img src={share} className='w-[24px] h-[24px]' alt="" />
                                    </div> */}
                                </div>
                            </div>
                            {
                                cardType.current != 2 && <ButtonComp mt={40} title={t("card.sale.buy")} callBack={() => {
                                    if (localStorage.getItem('token')) {
                                        setConfirmBuyPopup(true)
                                    } else {
                                        dispatch(changeLoginState(true))
                                    }

                                }}>
                                    {!!actionArr?.first_buy_reward && <div style={{
                                        width: '62px',
                                        height: '18px',
                                        background: 'linear-gradient( 125deg, #EF4444 0%, #E88585 100%)',
                                        borderRadius: '0px 9px 0px 9px'
                                    }} className=" text-[#fff] text-[12px] leading-[15px] absolute z-10 -right-[2px] flex items-center justify-center -top-2 ">
                                        {FormattingTwoNumber(Number(actionArr?.first_buy_reward))}
                                        <img src={coins} className=" w-[14px] ml-[6px] h-[10px]" alt="" />
                                    </div>}
                                </ButtonComp>
                            }
                            {
                                (cardType.current == 2 && isNft.current) && <ButtonComp mt={40} title={t("card.sale.buy")} callBack={() => {
                                    const url = import.meta.env.VITE_TRADE_URL + import.meta.env.VITE_MINT_CONTRACT_ADDRESS
                                    window.open(url, '_blank')
                                }}>
                                    {!!actionArr?.first_buy_reward && <div style={{
                                        width: '62px',
                                        height: '18px',
                                        background: 'linear-gradient( 125deg, #EF4444 0%, #E88585 100%)',
                                        borderRadius: '0px 9px 0px 9px'
                                    }} className=" text-[#fff] text-[12px] leading-[15px] absolute z-10 -right-[2px] flex items-center justify-center -top-2 ">
                                        {FormattingTwoNumber(Number(actionArr?.first_buy_reward))}
                                        <img src={coins} className=" w-[14px] ml-[6px] h-[10px]" alt="" />
                                    </div>}
                                </ButtonComp>
                            }
                        </>}
                    </div>
                </div>
                <PublicDialog width={'290'} teleport={popupRef.current} dialog={is_report} setDialog={setReport} content={reportText()}></PublicDialog>
                {/* {actionArr?.image && <ShareContent teleport={popupRef.current} shareDialog={shareDialog} setShareDialog={setShareDialog} image={actionArr.image}></ShareContent>} */}
                <ShareContent
                    bonusPower={actionArr?.bonus_power}
                    power={actionArr?.power}
                    property={actionArr?.property}
                    enhanceLevel={actionArr?.enhance_level}
                    mint_state={actionArr?.mint_state}
                    is_nft={actionArr?.is_nft}
                    level={actionArr?.is_official ? 6 : actionArr?.level + 1}
                    shareStatus={shareStatusList?.cardDomainShare}
                    code={'cardDomainShare'}
                    cardId={actionArr.id}
                    teleport={popupRef.current}
                    shareDialog={shareDialog}
                    setShareDialog={setShareDialog}
                    image={actionArr.image}
                    pageName={typeActive == 2 ? 'Sale' : 'Display'}
                >
                </ShareContent>

            </Popup>
            <Popup
                destroyOnClose={true}
                closeOnPopstate={true}
                style={{ width: '100%', height: '12.8125rem', borderRadius: '1.875rem 1.875rem 0 0' }}
                position='bottom'
                teleport={popupRef.current}
                onClose={() => { setConfirmBuyPopup(false) }}
                visible={confirmBuyPopup && buyPopup}>
                <div className='w-full rounded-[1.875rem_1.875rem_0_0] px-[2.875rem] py-10 h-full absolute bottom-0' style={{ backgroundImage: `linear-gradient( 135deg, #CFFFAF 0%, #FFFFFF 100%)`, }}>
                    {Array.isArray(actionArr?.creator) && <p className='text-[1rem] text-[#333] leading-[1.1875rem] font-bold'>{t("card.sale.creator")}:  {actionArr?.creator.length > 7 ? formatIdString(actionArr?.creator) : actionArr?.creator}</p>}
                    <p className='text-[1rem] text-[#333] leading-[1.1875rem] mt-[1.125rem] mb-[1.875rem] flex items-center font-bold'>{t("card.index.price")}: <img className='w-[1.375rem] mx-[.375rem]' src={coin} alt="" /> <span className='text-[1rem] text-style-6 leading-[1.1875rem] '>{formatNumber(+ actionArr?.price)}</span></p>
                    {/* <div className='bg-gradient-to-r button_shadow text-[#fff] from-[#00E49F] to-[#54ADFF] w-[100%] h-[2.25rem] rounded-[.625rem]'
                        onClick={
                            () => {
                                Buy(actionArr?.id, actionArr?.price)
                                setBuyCard(actionArr)
                            }
                        }
                    >
                        {loading ? <img className='w-5 h-5 animate-spin' src={loadingImg} /> : {t("card.sale.buy")}}
                    </div> */}
                    <ButtonComp isLoading={loading} width={"100%"} title={t("card.sale.buy")} callBack={() => {
                        Buy(actionArr?.id, actionArr?.price)
                        setBuyCard(actionArr)
                    }}>
                        {!!actionArr?.first_buy_reward && <div style={{
                            width: '62px',
                            height: '18px',
                            background: 'linear-gradient( 125deg, #EF4444 0%, #E88585 100%)',
                            borderRadius: '0px 9px 0px 9px'
                        }} className=" text-[#fff] text-[12px] leading-[15px] absolute z-10 -right-[2px] flex items-center justify-center -top-2 ">
                            {FormattingTwoNumber(Number(actionArr?.first_buy_reward))}
                            <img src={coins} className=" w-[14px] ml-[6px] h-[10px]" alt="" />
                        </div>}
                    </ButtonComp>

                </div>
            </Popup >

            <PromptDialog
                title={text}
                dialog={dialog}
                teleport={document.querySelector("body")}
                power={promptCard?.power - promptCard?.enhance_power}
                property={promptCard?.property} no={`No: ${convertNumber(seq?.seq)}`}
                name={promptCard.description} image={promptCard.image}
                level={promptCard.is_official ? 6 : promptCard?.level + 1}
                setDialog={setDialog}
                text={promptText}
                callback={() => {
                    seq.reward == 0 && callback && callback()
                    seq.reward && setClaimPointsDialog(true)
                }}
            >
            </PromptDialog>

            <PromptDialog
                title={text}
                isClose={true}
                dialog={purchaseSuccessfulDialog}
                teleport={document.querySelector("body")}
                power={promptCard?.power - promptCard?.enhance_power}
                property={promptCard?.property} no={`No: ${convertNumber(seq?.seq)}`}
                name={promptCard.description} image={promptCard.image}
                level={promptCard.is_official ? 6 : promptCard?.level + 1}
                setDialog={setPurchaseSuccessfulDialog}

                text={promptText}
                children={
                    <ShareComp
                        bonusPower={promptCard.bonus_power}
                        power={promptCard.power}
                        property={promptCard.property}
                        enhanceLevel={0}
                        mint_state={0}
                        level={promptCard?.is_official ? 6 : promptCard?.level + 1}
                        is_nft={false}
                        code={'purchaseCardShare'}
                        image={promptCard?.image}
                        shareStatus={shareStatusList.purchaseCardShare}
                        callback={() => {
                            seq.reward == 0 && callback && callback()
                            seq.reward && setClaimPointsDialog(true)
                        }}>
                    </ShareComp>
                }
            >
            </PromptDialog>

            {
                coin_NSFW && <NsfwPay type={14} closeHandle={async (val) => {
                    setCoin_NSFW(false)
                    if (!val) {
                        return;
                    }
                    try {
                        const result = await postSetting(localStorage.getItem('userId'), { ...settings, nsfw: true, order_id: val })
                        if (result.code == 0) {
                            dispatch(changeSettings({ ...settings, nsfw: true }))
                            setUserInfo()
                        } else {
                            setText(t("other.attention"))
                            setPromptText(t("other.neterror"))
                            setDialog(true)
                        }
                        let ID = window.localStorage.getItem("userId") || "";

                        const setting = await getSetting(ID)
                        if (setting.code == 0) {
                            dispatch(changeSettings(setting.data))
                        } else {
                            setText(t("other.attention"))
                            setPromptText(t("other.neterror"))
                            setDialog(true)
                        }
                    } catch {
                        setText(t("other.attention"))
                        setPromptText(t("other.neterror"))
                        setDialog(true)

                    }
                }


                }></NsfwPay>
            }
            {
                showPayDialog && <PayDialog teleport={popupRef.current} isNeedDialogSuccess={false} dataList={payList} title={t("card.main.purchase_image_download")} callBack={async (val) => {
                    setShowPayDialog(false)
                    if (val != 'close') {
                        const match = actionArr.image.match(/\.([a-zA-Z0-9]+)$/);
                        const params = {
                            url: actionArr.image,
                            file_name: `${uuidv4()}${match[0]}`
                        }
                        try {
                            downloadFile(params)
                            await updateDownLoadCount(actionArr.id)
                            // getCardInoHandle()
                        } catch (e) {
                        }
                    }
                }} />
            }
            <GetCoinAnimationDialog
                dialog={claimPointsDialog}
                point={seq?.reward}
                getCoinAnimation={getCoinAnimation} setDialog={() => {
                    setClaimPointsDialog(false)
                    callback && callback()
                }}>
            </GetCoinAnimationDialog>

            <PromptDialog
                title={t("other.attention")}
                dialog={payDialog} setDialog={setPayDialog}
                callback={() => { setDialog(false) }}
                text={promptText}></PromptDialog>
            {/* <audio ref={closeAudioRef} src={closeMusic} id="audio"></audio> */}
        </ >
    )
}


export default Sale;
